import { render, staticRenderFns } from "./DesignDataUploader.vue?vue&type=template&id=fc81e946&"
import script from "./DesignDataUploader.vue?vue&type=script&lang=js&"
export * from "./DesignDataUploader.vue?vue&type=script&lang=js&"
import style0 from "./DesignDataUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports